export const serializeFiles = (files) => files.map((file) => {
  return {
    ...file,
    file: { name: file.originalname, link: file.file }
  };
});